module.exports = __webpack_public_path__ + "static/media/left-active-carosul.143e8795.svg";